import type { FC } from 'react';

import { Logger } from '../../../../logger/Logger';
import { useCoreDispatch } from '../../../../store/CoreStore';
import { useChatSlice } from '../../../../store/slices/chat/selectors';
import { chatActions } from '../../../../store/slices/chat/slice';
import { ChatTabType } from '../../../../store/slices/chat/types';
import { useConfigSlice } from '../../../../store/slices/config/selectors';

import { LiveSupportControlPlain } from './LiveSupportControlPlain';

export const LiveSupportControlConnected: FC = () => {
  const dispatch = useCoreDispatch();
  const isChatDisabled = useConfigSlice.isChatDisabled();
  const isGameChatClosed = useChatSlice.getIsChatClosed();
  const chatStatus = useChatSlice.getSelectedTab();
  const isSupportTabSelected = chatStatus === ChatTabType.LiveSupportChat;
  const isGameChatTabSelected = chatStatus === ChatTabType.GameChat;
  const isLiveSupportRead = useChatSlice.getIsLiveSupportRead();

  if (isChatDisabled) {
    return null;
  }

  return (
    <LiveSupportControlPlain
      condition={!isGameChatClosed && isSupportTabSelected}
      onClick={(): void => {
        if (isGameChatClosed || isGameChatTabSelected) {
          dispatch(chatActions.setSelectedTab(ChatTabType.LiveSupportChat));
          dispatch(chatActions.setLiveSupportReadStatus(true));
          dispatch(chatActions.setIsChatClosed(false));
          dispatch(chatActions.setDisplayMiniChat(false));
          Logger.logEvent('click', 'chatModalOpen', Date.now(), 1, 'support', false);
        } else {
          dispatch(chatActions.setIsChatClosed(true));
          dispatch(chatActions.setDisplayMiniChat(true));
        }
      }}
      showBadge={!isLiveSupportRead}
    />
  );
};
